import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from '../outline-button-baseline/outline-button-baseline.css.lit';
import '../outline-icon-baseline/outline-icon-baseline';

/**
 * The OutlineFileLink component
 * @element outline-file-link
 */
@customElement('outline-file-link')
export class OutlineFileLink extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * URL for the downloadable file
   */
  @property({ type: String })
  url: string;

  /**
   * Display name for the file.
   */
  @property({ type: String, attribute: 'file-name' })
  fileName: string;

  render(): TemplateResult {
    return html`
      <outline-button-baseline class="outline-file-link">
        <a
          class="btn secondary large has-left-icon"
          aria-label="download ${this.fileName}"
          href="${this.url}"
          download
        >
          <div class="left-icon-container">
            <outline-icon-baseline
              name="eu-download"
              library="system"
              size="1.15rem"
            ></outline-icon-baseline>
          </div>
          Download ${this.fileName}
        </a>
      </outline-button-baseline>
    `;
  }
}
